<div class="page-header">
  <div class="grid-container">
    {{changeRequestVO.id}}
  </div>
</div>
<div class="grid-container">
<div id="authorize-header">
  Review change request for {{changeRequestVO?.tldName | domainNameConverter}}
</div>

<div class="finalize-request">
  <fa-icon [icon]="'exclamation-triangle'" class="iana-icons align-center"></fa-icon>
  <div style="padding-left: 16px;">
    <div class="grid-x">
      If you are satisfied with the changes, choose “I approve this change request”. If you do not agree to
      the changes because they are not correct, or they are being proposed without authorization, choose
      “I reject this change request”. Click “Submit” to record your response.
    </div>
  </div>
</div>

<div class="header-helper" style="padding-bottom: 0 !important;">
  <p>As an authorizer for the {{changeRequestVO?.tldName | domainNameConverter}} top-level domain, please review the following proposed change request
    submitted by {{changeRequestVO?.requestMetadata?.submitterEmail}} on {{changeRequestVO?.requestMetadata?.dateOfSubmission | commonDate}}.</p>

  <p>If you have any questions, contact IANA Root Zone Management at root-mgmt&#64;iana.org.</p>
</div>
<changes-requested-block *ngIf="changeRequestVO.id" [changeRequestVO]="changeRequestVO"></changes-requested-block>
<div class="content-header">
  Actions
</div>
<div class="content content-with-elevation" style="margin-top: 16px">
  <form [formGroup]="changeRequestAcceptRejectForm"
        novalidate (submit)="onSubmit()">
    <div class="requestDetailsContent">
      <p>Enter your response for this change request. Your response and reason will be recorded.</p>

      <div class="grid-x">
        <fieldset>
          <input type="radio" formControlName="changeRequestAction" value="APPROVE" id="approve"
                 (change)="resetRejectComments($event)" required>
                 <label for="approve">I approve this change request.</label><br/>
          <input type="radio" formControlName="changeRequestAction" value="REJECT" id="reject" required><label
          for="reject">I reject this change request.</label>
        </fieldset>
      </div>
      <div class="grid-x" *ngIf="this.changeRequestAcceptRejectForm.value.changeRequestAction === 'REJECT'">
        <div class="cell medium-12 large-12 small-12"><textarea [ngModel]="rejectReasonComment" formControlName="comment"
                                                                placeholder="Please provide an explanation for rejecting here."
                                                                maxlength="256"
                                                                class="input-group-custom"
                                                                style="width: 100%"></textarea>
          <lib-whitelist-character-error [whitelistFormControl]="comment"></lib-whitelist-character-error>

        </div>
      </div>
    </div>
    <div class="save-cancel-button-group grid-x">
      <button class="iana-button" type="submit" [disabled]="isFormInValid()">Submit
      </button>
    </div>
  </form>
</div>
</div>
